export const ROW_INDEX_ATTRIBUTE = 'data-row-index'
export const COLUMN_INDEX_ATTRIBUTE = 'data-column-index'
export const SCROLL_SYNC_CONTEXT = '$$GRID_SCROLL_SYNC_CONTEXT$$'
export const COL_IDENT_ATTRIBUTE = 'data-col-ident'
